import { useTranslation } from "react-i18next";
import styles from "./VMVDescription.module.scss";

function VMVDescription() {
  const { t } = useTranslation();
  return (
    <article className={styles.vmvDescription}>
      <div className={styles.vmvDescription__container}>
        <strong>{t("vmvDescription.strongText")}</strong>
        <p style={{ textAlign: 'center' }}><a type="button" href="/flyer.pdf" target="_blank" >{t("vmvDescription.download")}</a></p>
        <br />
        <p>{t("vmvDescription.paragraph2")}</p>
        <p>{t("vmvDescription.paragraph3")}</p>
        <br />
        <p>{t("vmvDescription.paragraph4")}</p>
        <strong>{t("vmvDescription.strongText2")}</strong>
      </div>
    </article>
  );
}

export default VMVDescription;
